import React, { useEffect, useState } from "react";
import CompanyContext from "./context";
import fetchCompany from "../../../../../services/company/fetchCompany";
import Company from "../../../../../app/domain/Company";

export default function CompanyWrapper(props: any) {
  const [isLoading, setIsLoading] = useState(false);
  const [company, setCompany] = useState(new Company({}));

  useEffect(() => {
    const loadCompany = async () => {
      setIsLoading(true);
      await fetchCompany({ callback: setCompany });
      setIsLoading(false);
    };
    loadCompany();
  }, []);

  return (
    <CompanyContext.Provider
      value={{ company, setCompany, isLoading, setIsLoading }}
      {...props}
    />
  );
}
